import { Alert, List, Typography } from "antd"
import { useTranslation } from "react-i18next"

import type { PendingSignature } from "../../Projects/api/services.types.ts"

const { Text } = Typography

interface PendingSignaturesAlertProps {
  signatures: PendingSignature[]
}

/** The signature requests an archive would withdraw, shared by the lead and project dialogs. */
export function PendingSignaturesAlert({
  signatures
}: PendingSignaturesAlertProps) {
  const { t } = useTranslation()

  return (
    <Alert
      type="error"
      showIcon
      className="mb-4"
      data-testid="archive-pending-signatures"
      message={t("esign.archive.title")}
      description={
        <>
          <div className="mb-2">
            {t("esign.archive.body", { count: signatures.length })}
          </div>
          <List
            size="small"
            dataSource={signatures}
            rowKey={(signature) => signature.id}
            renderItem={(signature) => (
              <List.Item className="!px-0">
                <div className="flex flex-col">
                  <Text strong>{signature.document_name}</Text>
                  <Text type="secondary" className="text-xs">
                    {[
                      signature.recipients.join(", "),
                      t(
                        `esign.recipientStatuses.${signature.furthest_progress}`
                      )
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </Text>
                </div>
              </List.Item>
            )}
          />
        </>
      }
    />
  )
}
